var scope_0 = require('/codebuild/output/src1873747541/src/klarity-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/23025400c749292e60843eb83fa12f8f.js').default;
var scope_1 = require('/codebuild/output/src1873747541/src/klarity-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/767812a948ea25e03c6abe9f54fbfbf1.js').default;
var scope_2 = require('/codebuild/output/src1873747541/src/klarity-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/81533cb39c991e9530cf9c05a7f5cee6.js').default;
var scope_3 = require('/codebuild/output/src1873747541/src/klarity-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    